// extracted by mini-css-extract-plugin
export default {"shareContainer":"SocialSharing_shareContainer__VslCC","socialMedialinks":"SocialSharing_socialMedialinks__GruSn","shareTitle":"SocialSharing_shareTitle__uE3W1"};